import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@user-portal/wikr-components';

import * as S from '../styled';

export const IncludedInYourPlanRow = ({ isCardRow = false }) => {
    const { t } = useTranslation();

    return (
        <S.ListContainer $paddingTop={8} $isCardRow={isCardRow}>
            <Text color={isCardRow ? 'text-main' : 'text-secondary'} mb={8}>
                {t('subscription.includedInYourPlan')}
            </Text>
            <S.List $isCardRow={isCardRow}>
                <li>
                    <Text color={isCardRow ? 'text-main' : 'text-secondary'} mb={8}>
                        {t('subscription.personalizedProgram')}
                    </Text>
                </li>
                <li>
                    <Text color={isCardRow ? 'text-main' : 'text-secondary'}>{t('subscription.premiumContent')}</Text>
                </li>
            </S.List>
        </S.ListContainer>
    );
};
